import { AlertCircle, CalendarRange, Loader2 } from "lucide-react";
import { DateInput } from "@/components/DateInput";
import { Label } from "@/components/ui/label";
import { ExportButtons } from "@/components/reports/ReportCard";
import { QUICK_RANGES } from "@/lib/ranges";
import { cn } from "@/lib/utils";

const Segmented = ({ value, options, onChange, testid }) => (
  <div className="inline-flex rounded-md border border-slate-200 bg-slate-50 p-0.5" data-testid={testid}>
    {options.map(([k, label]) => (
      <button key={k} type="button" onClick={() => onChange(k)} data-testid={`${testid}-${k}`}
        className={cn("rounded px-3 py-1.5 text-xs font-medium transition-colors", value === k ? "bg-slate-900 text-white shadow-sm" : "text-slate-600 hover:text-slate-900")}>
        {label}
      </button>
    ))}
  </div>
);

export const ReportControls = ({ from, to, view, error, loading, onFrom, onTo, onView, onRange, params, disabled }) => {
  const active = QUICK_RANGES.find((q) => { const [f, t] = q.range(); return f === from && t === to; })?.key;
  return (
    <section className="rise-in sticky top-16 z-20 rounded-lg border border-slate-200 bg-white/95 p-5 shadow-sm backdrop-blur" data-testid="report-controls">
      <div className="flex flex-wrap items-end gap-x-6 gap-y-4">
        <div className="space-y-1.5">
          <Label htmlFor="report-from" className="text-xs text-slate-600">From</Label>
          <DateInput id="report-from" value={from} onChange={onFrom} testid="report-from-input" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="report-to" className="text-xs text-slate-600">To</Label>
          <DateInput id="report-to" value={to} onChange={onTo} testid="report-to-input" />
        </div>
        <div className="space-y-1.5">
          <div className="text-xs font-medium text-slate-600">View</div>
          <Segmented value={view} onChange={onView} testid="view-toggle" options={[["monthly", "Monthly"], ["daily", "Daily"]]} />
        </div>
        <div className="ml-auto space-y-1.5">
          <div className="text-xs font-medium text-slate-600">Export full report</div>
          <ExportButtons report="full" params={params} disabled={disabled} labelPrefix="Full" />
        </div>
      </div>
      <div className="mt-4 flex flex-wrap items-center gap-2">
        <CalendarRange className="h-4 w-4 text-teal-600" />
        {QUICK_RANGES.map((q) => (
          <button key={q.key} type="button" onClick={() => onRange(q.range())} data-testid={`quick-range-${q.key}`}
            className={cn("rounded-full border px-3 py-1 text-xs font-medium transition-colors", active === q.key ? "border-teal-600 bg-teal-50 text-teal-800" : "border-slate-200 text-slate-600 hover:border-slate-400")}>
            {q.label}
          </button>
        ))}
        {loading && <Loader2 className="h-4 w-4 animate-spin text-slate-400" data-testid="report-loading" />}
      </div>
      {error && (
        <div className="mt-4 flex items-center gap-2 rounded-md border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="report-range-error">
          <AlertCircle className="h-4 w-4" /> {error}
        </div>
      )}
    </section>
  );
};
